export default __webpack_public_path__ + "static/media/MPMobileBackground.5474217a.png";